import api from './api';

const commissionService = {
  getCommissions: async (params = {}) => {
    const response = await api.get('/commissions', { params });
    return response.data;
  },
  getOptions: async () => {
    const response = await api.get('/commissions/options');
    return response.data;
  },
  createCommission: async (payload) => {
    const response = await api.post('/commissions', payload);
    return response.data;
  },
  updateCommission: async (id, payload) => {
    const response = await api.put(`/commissions/${id}`, payload);
    return response.data;
  },
  markPaid: async (id, paymentDate) => {
    const response = await api.post(`/commissions/${id}/mark-paid`, { payment_date: paymentDate });
    return response.data;
  },
  deleteCommission: async (id) => {
    const response = await api.delete(`/commissions/${id}`);
    return response.data;
  }
};

export default commissionService;
